export default __webpack_public_path__ + "static/media/be-sure-step2.f09ddf8d.png";